import React from "react";
import Lottie from "react-lottie";
import readingBook from "../../../assets/reading-book.json";

const Education = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: readingBook,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div className="pt-24">
      <div className="mb-12">
        <h1 className="text-4xl font-semibold drop-shadow-md text-center">
          My <span className="text-primary">Qualification</span>
        </h1>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-8">
        <div className="mx-auto lg:ml-auto">
          <Lottie
            options={defaultOptions}
            height="70%"
            width="90%"
            className="mx-auto lg:mr-auto"
          />
        </div>
        <div className="mx-auto lg:ml-auto">
          {/* B-tech in CSE */}
          <div className="p-6 bg-[#313131] bg-opacity-90 backdrop-blur-lg rounded-lg shadow-lg inline-block w-[300px] hover:shadow-primary duration-300 cursor-pointer">
            <h2 className="text-2xl font-semibold text-white mb-4">
              BE - Mechanical
            </h2>
            <p className="text-gray-300">Karpagam university, Coimbatore</p>
            <p className="text-gray-300">2014 - 2018</p>
            <p className="text-gray-300">CGPA: 6.98/10</p>
            {/* Add any additional information about your B-Tech here */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Education;
